import { RaceControl } from "api";

export enum StatusRace {
    IN_PROGRESS = "IN_PROGRESS",
    DONE = "DONE",
}

export enum DiscardType {
    CHANGE_CAR = "CHANGE_CAR",
    WORST_RESULT = "WORST_RESULT",
}

export interface RaceResult {
    raceNumber: number;
    driverId: string;
    originalPosition: number;
    position: number;
    originalClassPosition: number;
    classPosition: number;
    carID: string;
    carName: string;
    classID: string;
    originalClassName: string;
    className: string;
    teamID: string;
    teamName: string;
    iRacingId: string;
    driverName: string;
    startPosition: string;
    classStartPosition: number;
    gainedPositions: number;
    carNumber: string;
    outID: string;
    outName: string;
    interval: string;
    lapsLead: string;
    qualifyTime: string;
    averageLapTime: string;
    fastestLapTime: string;
    fastLap: string;
    lapsComplete: string;
    completedLapsPercentange: number;
    incidents: number;
    penaltyPoints: number;
    originalPoints: number;
    penaltyChampPoints: number;
    bonusPoints: number;
    points: string;
    messagesForBonusPoints: [string];
    messagesForPenaltyChampPoints: [string];
    messagesForPenaltyPoints: [string];
    discard: boolean;
    discardType?: DiscardType;
}

export interface Race {
    id: string;
    championshipId?: string;
    roundId?: string;
    raceNumber: number;
    createdBy?: string;
    createdAt?: any;
    raceControl?: RaceControl;
    status?: StatusRace;
    results?: RaceResult[];
}
